// extracted by mini-css-extract-plugin
export default {"Title":"Login_Title__etfOe"};